import script from "./CustomApiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomApiPage.vue?vue&type=script&setup=true&lang=js"

import "./CustomApiPage.vue?vue&type=style&index=0&id=f5ad39d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5ad39d8"]])

export default __exports__